import { Listings } from 'containers/AppContainer/typings';
import React, { useMemo, useRef, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid, Typography } from '@material-ui/core';
import { EMPTY_INVOICE_INFO, PROCEDURE_STEPS } from 'containers/data-structure';
import { cloneDeep, get, isEmpty, uniqueId, isNil } from 'lodash';
import { Container } from 'containers/LawyerLegalProceedingsPage/judgementAdd/styled-components';
import {
  IJudgementAdd,
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import { resolveSagisClaim } from 'helpers/utils';
import currentUserStorage from 'containers/services/security/current-user-storage';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { extractIntervenant } from 'containers/RecapPage/utils';
import ProcedureInformationRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/ProcedureInformationRecap';
import CivilPartyRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/CivilPartyRecap';
import { translate } from 'containers/services/translate';
import civilPartyMessages from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/messages';
import judgementAddPronouncingMessages from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/messages';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import JudgementAddPronouncingRecapAccordion from 'containers/common/LegalProceedings/JudgementAdd/Recap/JudgementAddPronouncingRecapAccordion';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/messages';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { EMPTY_ADD, PROCEDURE_STATUSES } from 'containers/data-structure';
import {
  CorporealDocument,
  JudgementADDDocumentType,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { Forms } from 'containers/common/LegalProceedings/JudgementAdd/Recap/styled-component';
import JudgementAddForm from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/JudgementAddForm';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { toast } from 'react-toastify';
import SuccessDialog from 'components/SuccessDialog';
import JudgementValidationButtons from 'containers/common/LegalProceedings/JudgementValidationButtons';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import {
  activateMultipleJudgementAdd,
  constructBodyJudgementAddMutipleToAdd,
  isDuplicateJudgementsAdd,
} from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import DecisionDropDownSupportDocument from 'containers/common/LegalProceedings/DecisionDropDownSupportDocument/index';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { DOCUMENT_TYPES } from 'constants/global';
import {
  SUPPORT_DOC_ID,
  SUPPORT_DOC_JUDGEMENT_ADD_ID,
} from 'containers/LawyerRecapPage/constants';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import Document from 'components/Document';
import { makeSelectFeeNotes } from 'containers/LawyerFeeNote/selectors';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
  getLimitInvoiceIntervenant,
  getLimitInvoiceManager,
  handleOpenDocument,
} from 'services/utils';
import ValidatorRecap from 'containers/common/LegalProceedings/ValidatorRecap';
import {
  isUserActive,
  showValidator,
} from 'containers/common/LegalProceedings/utils';
import ImportImagineDocumentButton from 'containers/CourtManagerLegalProceedings/ImagineDocuments/ImportButton';
import { useSelector } from 'react-redux';
import JudgementAddDecisionRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/JudgementAddDecisionRecap';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import FirmReferenceForm from 'components/FirmReferenceForm';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import UpdateStepRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/UpdateStepRecap';
import { DIALOGS } from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import { BUTTON_COLORS } from 'constants/design';
import InvoiceFeeNoteDialog from 'components/InvoiceFeeNoteDialog';
import InvoiceInfoDialog from 'components/InvoiceFeeNoteDialog/InvoiceInfoDialog';
import InvoiceFeeNotesManagerDialog from 'components/InvoiceFeeNoteDialog/InvoiceFeeNotesManagerDialog';
import DynamiqDialog from 'components/InvoiceFeeNoteDialog/DynamiqDialog';
import {
  getPendingFeeNotesByStep,
  getVictims,
  getVictimsIncome,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import IncomeCertificate from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate';
import { hasIncomeCertificate } from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate/utils';
import IncomeCertificatesRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/IncomeCertificatesRecap/index';
import { isBlockStatusClaim } from 'containers/CourtManagerLegalProceedings/utils';
import { FeeNoteType, VictimType } from 'typings/globalTypes';
import moment from 'moment';
export interface RecapADDProps {
  intl: IntlShape;
  listings: Listings;
  judgementAdd: IJudgementAdd | {};
  judgementAddStore?: IJudgementAdd;
  readOnly?: boolean;
  isCivilProceeding: boolean;
  //using any temporarly until we implement hooks to pass props between components and drawers
  handleOnEditCivilPartyClick?: any;
  handleOnEditJudgementAddClick?: any;
  handleOnEditProcedureInfoClick?: any;
  stakeholders?: any;
  assignedLawyer: any;
  victims: VictimType[];
  vehicules: Vehicule[];
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestCreateMultipleJudgementAdd?: Function;
  claimNumber: string;
  judiciaryProcessId: number;
  isManager: boolean;
  policyInfo: any;
  requestMakeJudgementAddDocumentDecision?: Function;
  document?: CorporealDocument;
  setDocument?: Function;
  documentAdd?: CorporealDocument;
  setDocumentAdd?: Function;
  index?: number;
  docType?: string;
  docId?: string;
  setDocumentId: Function;
  documentId: string;
  setJudgementAdd?: Function;
  requestUpdateJudgementAddDocument?: Function;
  currentJudiciaryProcess?: any;
  isAssignedLawyer?: boolean;
  setDialogOpenFirmReference?: Function;
  isCreator?: boolean;
  requestGetJudgementAdd?: Function;
  expertReport?: ExpertReportType;
  judgementOnMerits?: JudgementOnMeritsType;
  handleIsDialogOpen?: Function;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  setIsButtonRedirect?: Function;
  feeNotes: any;
  setOpenFeeNoteDialog: Function;
  requestCreateIncomeCertificate?: Function;
  requestUpdateIncomeCertificate?: Function;
  requestMakeDecisionIncomeCertificate?: Function;
  isConsultation: boolean;
  riskKey: string;
  requestMakeDecisionSupportDocument?: Function;
  imagineDocuments: any;
  dahirAmount: [];
  requestGetDocByDocumentumId: Function;
}

export const RecapADD: React.FC<RecapADDProps> = (props): JSX.Element => {
  const {
    judgementAdd,
    civilDocuments,
    judgementAddDocuments,
    supportDocuments = [],
  } = props.judgementAdd as IJudgementAdd;
  const [
    judgemenAddDocumentToUpdate,
    setJudgemenAddDocumentToUpdate,
  ] = useState({});
  const [
    decisionGenerationFeeNote,
    setDecisionGenerationFeeNote,
  ] = React.useState(null);
  const [
    openInvoiceFeeNoteInfoDialog,
    setOpenInvoiceFeeNoteInfoDialog,
  ] = React.useState(false);
  const [lawyerFirmRef, setLawyerFirmRef] = React.useState(null);
  const [invoiceDocument, setInvoiceDocument] = React.useState({});
  const [invoiceNumber, setInvoiceNumber] = React.useState(null);
  const [invoiceDate, setInvoiceDate] = React.useState(null);
  const [invoiceFeeNoteInfos, setInvoiceFeeNoteInfo] = React.useState<any>([]);
  const [openInvoiceInfoLawyers, setOpenInvoiceInfoLawyers] = React.useState<
    boolean
  >(false);
  const currentFeeNoteIndexRef = useRef<number>(0);
  const [currentFeeNoteIndex, setCurrentFeeNoteIndex] = useState<number | null>(
    null,
  );
  React.useEffect(() => {
    if (currentFeeNoteIndex !== null) {
      currentFeeNoteIndexRef.current = currentFeeNoteIndex;
    }
  }, [currentFeeNoteIndex]);
  const claimAssignment = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'assignment'], []),
  );
  const claim = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap'], []),
  );
  const claimId = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'id'], []),
  );
  const claimRecap = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap'], []),
  );
  const feeNotesStore = useSelector(makeSelectFeeNotes());
  const [invoiceFeeNotes, setInvoiceFeeNotes] = useState([]);

  const lawyerAssignment =
    claimAssignment.find(
      (el: any) =>
        el.assignedLawyer === currentIntervenantStorage.get()?.sagis_code &&
        el.judiciaryProcessId === props.judiciaryProcessId &&
        el.isDeleted === false,
    ) || {};
  const assignedLawyersByJudiciaryProcess = claimAssignment.filter(
    (el: any) =>
      el.judiciaryProcessId === props.judiciaryProcessId &&
      el.isDeleted === false,
  );
  const lawyerFirmReference = get(lawyerAssignment, 'firmReference', null);

  const judgementAddSupportDocuments = supportDocuments.filter(
    (el: any) => el.type === DOCUMENT_TYPES.SUPPORT_DOCUMENT_JUDGEMENT_ADD,
  );

  const civilPartySupportDocuments = supportDocuments.filter(
    (el: any) => el.type === DOCUMENT_TYPES.SUPPORT_DOCUMENT_CIVIL_PARTY,
  );

  const [isSuccessPopinOpen, setIsSuccessPopinOpen] = React.useState<boolean>(
    false,
  );
  const [invoiceDocumentUpdate, setInvoiceDocumentUpdate] = useState({});
  const [invoiceNumberUpdate, setInvoiceNumberUpdate] = useState(null);
  const [invoiceDateUpdate, setInvoiceDateUpdate] = useState(null);

  const [judgementAddPronouncings, setJudgementAddPronouncings] = useState<any>(
    { [uniqueId()]: cloneDeep(EMPTY_ADD) },
  );

  const [newJudgementADDDocuments, setNewJudgementADDDocuments] = useState<
    JudgementADDDocumentType[]
  >([]);

  const [
    openInvoiceFeeNoteUpdateInfoDialog,
    setOpenInvoiceFeeNoteUpdateInfoDialog,
  ] = useState<boolean>(false);
  const handleCloseInvoiceFeeNoteUpdate = () => {
    setOpenInvoiceFeeNoteUpdateInfoDialog(false);
  };
  const feeNotes = useMemo(
    () =>
      getPendingFeeNotesByStep(
        feeNotesStore,
        PROCEDURE_STEPS.JUDGEMENT_ADD,
        null as any,
        !isEmpty(judgemenAddDocumentToUpdate)
          ? [get(judgemenAddDocumentToUpdate, 'id')]
          : [],
        currentIntervenantStorage?.get()?.sagis_code,
      ),
    [],
  );

  const handleValidateUpdateInvoice = () => {
    const currentItem = feeNotes[currentFeeNoteIndexRef.current];
    const invoiceFeeNoteId = get(currentItem, 'invoiceFeeNote.id');
    const updatedInvoiceFeeNotes = [
      ...invoiceFeeNotes,
      {
        id: invoiceFeeNoteId,
        invoiceNumber: invoiceNumberUpdate,
        invoiceDate: invoiceDateUpdate,
        receptionDate: moment().format('YYYY-MM-DD'),
        ...invoiceDocumentUpdate,
      },
    ];
    setInvoiceFeeNotes(updatedInvoiceFeeNotes as any);

    setInvoiceNumberUpdate('' as any);
    setInvoiceDocumentUpdate({});
    setInvoiceDateUpdate(null);
    setOpenInvoiceFeeNoteUpdateInfoDialog(false);
    if (
      updatedInvoiceFeeNotes.length ===
      feeNotes.map((el: any) => el.invoiceFeeNote).length
    ) {
      setCurrentFeeNoteIndex(null);
      handleValidate(judgemenAddDocumentToUpdate, updatedInvoiceFeeNotes);
    } else {
      currentFeeNoteIndexRef.current = currentFeeNoteIndexRef.current + 1;
      setCurrentFeeNoteIndex(currentFeeNoteIndexRef.current);
      setOpenInvoiceFeeNoteUpdateInfoDialog(true);
    }
  };

  const handleValidate = (
    judgemenAddDocumentToUpdateObject: any,
    invoiceFeeNotes?: any,
  ) => {
    if (
      props.requestUpdateJudgementAddDocument &&
      !isEmpty(judgemenAddDocumentToUpdateObject)
    ) {
      props.requestUpdateJudgementAddDocument(
        {
          judgementAddDocument: {
            ...judgemenAddDocumentToUpdateObject,
            rejectionReason: null,
            status: PROCEDURE_STATUSES.PENDING,
            validator: null,
          },
          claimId: get(props.judgementAdd, 'claimId'),
          procedureType: get(props.judgementAdd, 'procedureType'),
          judiciaryProcessId: get(props.judgementAdd, 'judiciaryProcessId'),
          claimNumber: props.claimNumber,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),

          invoiceFeeNotes: invoiceFeeNotes,
          isLawyer: currentIntervenantStorage?.get() ? true : false,
          isInboxesActive: featureService.hasFeature(
            FEATURES.ATTRIBUTION_INBOXES_MANAGER,
          ),
        },
        handleSuccessCallbackUpdate,
      );
    }
  };
  const handleSuccessCallbackUpdate = () => {
    toast.success(translate(messages.updateMessage, props));
    pushTo(PAGES.LAWYER_ASSIGNMENTS)();
  };
  const [showDuplicateWarning, setShowDuplicateWarning] = useState<boolean>(
    false,
  );

  const [isActive, setisActive] = useState(false);

  const addNewJudgementAddDocument = () => {
    setisActive(true);
    const judgement = {
      ...judgementAddPronouncings,
      [uniqueId()]: cloneDeep(EMPTY_ADD),
    };

    isActive && setJudgementAddPronouncings(judgement);
  };

  const saveForm = (judgement: any) => {
    if (isDuplicateJudgementsAdd(judgement, judgementAddDocuments)) {
      return setShowDuplicateWarning(true);
    }
    const JAD = [...newJudgementADDDocuments];
    JAD.push({
      ...judgement,
      byManager: props.isManager,
    });
    setNewJudgementADDDocuments(JAD);
    setShowDuplicateWarning(false);
  };
  const createMultipleJudgementAdd = (withFeeNote: boolean) => {
    props.isManager &&
      props.setIsButtonRedirect &&
      props.setIsButtonRedirect(true);
    props.requestCreateMultipleJudgementAdd &&
      props.requestCreateMultipleJudgementAdd(
        constructBodyJudgementAddMutipleToAdd(
          judgementAdd,
          props.judgementAdd,
          newJudgementADDDocuments,
          props.claimNumber,
          props.isManager,
          props.judiciaryProcessId,
          decisionGenerationFeeNote,
          assignedLawyersByJudiciaryProcess,
          withFeeNote,
          invoiceFeeNoteInfos,
          lawyerFirmRef,
          lawyerAssignment,
          invoiceNumber,
          invoiceDate,
          invoiceDocument,
          lawyerFirmReference,
        ),
        successCallBack(withFeeNote),
      );
  };
  const handleChangeJudgementAddProunoucing = (index: number) => (
    judgement: JudgementADDDocumentType,
  ) => {
    const judgementADD = { ...judgementAddPronouncings };
    if (!isEmpty(judgement)) {
      judgementADD[index] = judgement;
    } else {
      //handling the case when emptying state
      delete judgementADD[index];
    }

    setJudgementAddPronouncings(judgementADD);
  };

  const handleOpenInvoicesInfoDialog = () => {
    setIsSuccessPopinOpen(false);
    if (props.isManager) {
      setOpenInvoiceInfoLawyers(true);
    } else {
      setOpenInvoiceFeeNoteInfoDialog(true);
    }
  };

  const handleCloseSuccessDialog = () => {
    setIsSuccessPopinOpen(false);
    doNotGenerateFeeNote();
  };

  const handleValidateInvoice = () => {
    handleClick();
    setOpenInvoiceFeeNoteInfoDialog(false);
  };

  const handleCloseInvoiceFeeNote = () => {
    setOpenInvoiceFeeNoteInfoDialog(false);
  };

  const cancelJudgement = (index: number) => () => {
    let judgement = { ...judgementAddPronouncings };
    delete judgement[index];
    setJudgementAddPronouncings(judgement);
  };

  const successCallBack = (withFeeNote: boolean) => () => {
    setNewJudgementADDDocuments([]);
    toast.success(translate(messages.successToastTitle, props));

    if (!featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE)) {
      withFeeNote && !props.isManager
        ? pushTo(PAGES.FEE_NOTE)()
        : !withFeeNote && !props.isManager
        ? pushTo(PAGES.LAWYER_ASSIGNMENTS)()
        : props.isManager && withFeeNote && pushTo(PAGES.MANAGER_FEE_NOTE)();
    } else {
      withFeeNote && !props.isManager
        ? pushTo(PAGES.FEE_NOTE)()
        : !withFeeNote &&
          !props.isManager &&
          pushTo(PAGES.LAWYER_ASSIGNMENTS)();
    }
  };
  const onValidate = () => {
    props.isManager
      ? !isEmpty(
          extractIntervenant(
            get(props.listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ),
        )
        ? setIsSuccessPopinOpen(true)
        : createMultipleJudgementAdd(true)
      : setIsSuccessPopinOpen(true);
  };
  React.useEffect(() => {
    if (props.isManager && !isEmpty(assignedLawyersByJudiciaryProcess)) {
      if (
        !isEmpty(
          extractIntervenant(
            get(props.listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ),
        )
      ) {
        setInvoiceFeeNoteInfo(
          extractIntervenant(
            get(props.listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ).map((item: any, index: any) => ({
            codeIntervenant: item.ItemKey,
            createdBy:
              currentUserStorage?.get() && currentUserStorage?.get().username,
            ...EMPTY_INVOICE_INFO,
          })),
        );
      }
    }
  }, [
    props.judiciaryProcessId,
    props.currentJudiciaryProcess,
    !claimAssignment,
  ]);
  const handleClick = () => {
    createMultipleJudgementAdd(true);
  };
  const doNotGenerateFeeNote = () => {
    createMultipleJudgementAdd(false);
  };
  const hasValidator = showValidator(
    get(props, 'judgementAdd.validator', ''),
    props.isManager || false,
  );

  const currentlawyerAssignment =
    claimAssignment.find(
      (el: any) =>
        el.judiciaryProcessId === props.judiciaryProcessId &&
        el.isDeleted === false,
    ) || {};
  return (
    <Container>
      {props.isManager && (
        <div style={{ fontWeight: 'bold', fontSize: '18px', color: 'red' }}>
          {!isUserActive(
            props.listings,
            get(currentlawyerAssignment, 'assignedLawyer'),
          ) &&
          !isEmpty(currentlawyerAssignment) &&
          !isEmpty(props.listings)
            ? translate(messages.userNotValidWarning, props, {
                lawyerName: getValueByCode(
                  get(currentlawyerAssignment, 'assignedLawyer', ''),
                  get(props.listings, 'inactiveIntervenants', []),
                ),
              })
            : ''}
        </div>
      )}
      {props.isManager && (
        <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
          {get(props, 'judgementAdd.creator', '')
            ? translate(messages.creatorTitle, props, {
                lawyer: get(props, 'judgementAdd.creator', ''),
              })
            : ''}
        </span>
      )}
      {!props.isManager &&
        !isBlockStatusClaim(props.policyInfo) &&
        !userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER) &&
        !userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) &&
        !userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER) &&
        !isEmpty(lawyerAssignment) && (
          <FirmReferenceForm
            firmReference={lawyerFirmReference}
            judiciaryProcessId={props.judiciaryProcessId}
            message={
              lawyerFirmReference === null
                ? translate(messages.lawyerFirmReferenceUpdateMessage, props)
                : translate(messages.lawyerFirmReferenceEditMessage, props)
            }
            formInputLabel={translate(
              messages.lawyerFirmReferenceDialogLabel,
              props,
            )}
            formInputName={translate(
              messages.lawyerFirmReferenceDialogLabel,
              props,
            )}
            validationButtonTitle={
              lawyerFirmReference === null
                ? translate(messages.saveButton, props)
                : translate(messages.editButton, props)
            }
            title={
              get(props, 'judgementAdd.creator', '')
                ? translate(messages.creatorTitle, props, {
                    lawyer: get(props, 'judgementAdd.creator', ''),
                  })
                : ''
            }
            setIsDialogOpenFirmReference={props.setDialogOpenFirmReference}
            isFeeNoteGenerated={false}
            assignment={lawyerAssignment}
            lawyerFirmReference={lawyerFirmReference}
            isForm
          />
        )}
      {(hasValidator ||
        userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER)) &&
        get(props, 'judgementAdd.status', '') !==
          PROCEDURE_STATUSES.PENDING && (
          <Grid direction="column">
            <Grid xs={3}>
              <ValidatorRecap
                validator={get(props, 'judgementAdd.validator', '')}
              />
            </Grid>
            <Grid xs={6}>
              <JudgementAddDecisionRecap
                judgementAdd={props.judgementAdd}
                judgementAddDocument={judgementAddDocuments as any}
              />
            </Grid>
          </Grid>
        )}
      <UpdateStepRecap updatedBy={get(props, 'judgementAdd.updatedBy', '')} />
      <section className="add-recap-bloc">
        {judgementAdd && (
          <ProcedureInformationRecap
            listings={props.listings}
            details={judgementAdd}
            readOnly={props.readOnly || !props.isCreator}
            stakeholders={props.stakeholders}
            handleOnEditClick={
              props.handleOnEditProcedureInfoClick &&
              props.handleOnEditProcedureInfoClick()
            }
            assignedLawyer={props.assignedLawyer}
            creator={get(props.judgementAdd, 'creator', null)}
            sagisOpposingParties={props.sagisOpposingParties}
          />
        )}
        {!props.isCivilProceeding && !isEmpty(civilDocuments) && (
          <main>
            <section className="add-recap-bloc">
              <div className="add-recap-bloc-title">
                {translate(civilPartyMessages.civilPartyBlocTitle, props)}
              </div>
              {!isEmpty(civilDocuments) &&
                civilDocuments.map((civilDocument, index: number) => (
                  <CivilPartyRecap
                    key={uniqueId('recap-civil-party-')}
                    index={index}
                    civilParty={civilDocument}
                    readOnly={props.readOnly || !props.isCreator}
                    editCivilParty={
                      props.handleOnEditCivilPartyClick &&
                      props.handleOnEditCivilPartyClick(index)
                    }
                    resetUploadedDocument={props.resetUploadedDocument}
                    uploadDocument={props.uploadDocument}
                    uploadedDocument={props.uploadedDocument}
                    document={props.document}
                    setDocument={props.setDocument}
                    setDocumentId={props.setDocumentId}
                    creator={get(props.judgementAdd, 'creator', null)}
                    sagisVictimInfo={props.sagisVictimInfo}
                    requestGetDocByDocumentumId={
                      props.requestGetDocByDocumentumId
                    }
                  />
                ))}
            </section>
            {!userPrivileges.userHasPrivilege(
              PRIVILEGES.ISCOURTMONITORINGMANAGER,
            ) ? (
              <>
                {featureService.hasFeature(FEATURES.ADD_SUPPORT_DOCUMENTS) &&
                  judgementAdd &&
                  (props.isAssignedLawyer ||
                    (props.isManager &&
                      featureService.hasFeature(
                        FEATURES.MANAGE_CLAIM_BY_MANAGER,
                      ))) && (
                    <main>
                      {isEmpty(civilPartySupportDocuments) && (
                        <section className="add-recap-bloc">
                          {props.document &&
                            props.setDocument &&
                            props.resetUploadedDocument &&
                            props.uploadDocument &&
                            props.uploadedDocument && (
                              <>
                                <div className="add-recap-bloc-title">
                                  {translate(messages.supportDocument, props)}
                                </div>

                                <Grid
                                  container
                                  direction="row"
                                  alignItems="center"
                                  spacing={2}
                                >
                                  <Grid item xs={5}>
                                    <UploadDocumentBloc
                                      index={1}
                                      document={props.document}
                                      setDocument={props.setDocument}
                                      resetUploadedDocument={
                                        props.resetUploadedDocument
                                      }
                                      uploadDocument={props.uploadDocument}
                                      uploadedDocument={props.uploadedDocument}
                                      docType={
                                        DOCUMENT_TYPES.SUPPORT_DOCUMENT_CIVIL_PARTY
                                      }
                                      setDocumentId={props.setDocumentId}
                                      docId={SUPPORT_DOC_ID}
                                      shouldNotCallReset={true}
                                    />
                                  </Grid>
                                  <Grid
                                    item
                                    xs={3}
                                    style={{ marginTop: '20px' }}
                                  >
                                    {!isEmpty(props.imagineDocuments) &&
                                      featureService.hasFeature(
                                        FEATURES.TRAITEMENT_IMAGINE_DOC,
                                      ) && (
                                        <ImportImagineDocumentButton
                                          listings={props.listings}
                                          managerNotifcationsInboxes={
                                            props.imagineDocuments
                                          }
                                          claimId={claimId}
                                          imagineDocuments={
                                            props.imagineDocuments
                                          }
                                          claimSagisInfo={resolveSagisClaim(
                                            props.policyInfo,
                                          )}
                                          uploadDocument={props.uploadDocument}
                                          uploadedDocument={
                                            props.uploadedDocument
                                          }
                                          setUploadedDocs={props.setDocument}
                                          documentName={
                                            DOCUMENT_TYPES.SUPPORT_DOCUMENT_CIVIL_PARTY
                                          }
                                          documentType={
                                            DOCUMENT_TYPES.SUPPORT_DOCUMENT_CIVIL_PARTY
                                          }
                                          documentId={SUPPORT_DOC_ID}
                                          setDocumentId={props.setDocumentId}
                                          requestGetDocByDocumentumId={
                                            props.requestGetDocByDocumentumId
                                          }
                                        />
                                      )}
                                  </Grid>
                                </Grid>
                              </>
                            )}
                        </section>
                      )}
                    </main>
                  )}
              </>
            ) : (
              <></>
            )}
            {featureService.hasFeature(FEATURES.ADD_SUPPORT_DOCUMENTS) &&
              !isEmpty(civilPartySupportDocuments) && (
                <section className="add-recap-bloc">
                  <div className="add-recap-bloc-title">
                    {translate(messages.supportDocument, props)}
                  </div>
                  <div className="support-document-info">
                    <Document
                      name={get(civilPartySupportDocuments[0], 'name', '')}
                      type={get(civilPartySupportDocuments[0], 'type', '')}
                      icon={
                        <VisibilityIcon
                          className="consult"
                          onClick={handleOpenDocument(
                            civilPartySupportDocuments[0],
                            props.requestGetDocByDocumentumId,
                          )}
                        />
                      }
                    />
                    {props.isManager && !props.isConsultation && (
                      <DecisionDropDownSupportDocument
                        claimId={claimId}
                        claimNumber={props.claimNumber}
                        judiciaryProcessId={props.judiciaryProcessId}
                        supportDocument={civilPartySupportDocuments[0]}
                        requestMakeDecisionSupportDocument={
                          props.requestMakeDecisionSupportDocument
                        }
                        claim={claim}
                        procedureType={get(
                          props.judgementAdd,
                          'procedureType',
                          '',
                        )}
                      />
                    )}
                  </div>
                </section>
              )}
          </main>
        )}

        <div className="update-button">
          {props.isManager &&
            featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
            !userPrivileges.userHasPrivilege(
              PRIVILEGES.ISCOURTMONITORINGMANAGER,
            ) &&
            get(props, 'judgementAdd.status', '') !==
              PROCEDURE_STATUSES.PENDING && (
              <PrimaryButton
                title={translate(messages.courtManagerJudgementUpdate, props)}
                onClick={
                  props.handleIsDialogOpen &&
                  props.handleIsDialogOpen(DIALOGS.VALIDATION, true, true, true)
                }
                background={BUTTON_COLORS.PRIMARY_BLUE}
                border={BUTTON_COLORS.PRIMARY_BLUE}
                titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                className="button"
              />
            )}
        </div>
      </section>
      <Forms>
        {!userPrivileges.userHasPrivilege(
          PRIVILEGES.ISCOURTMONITORINGMANAGER,
        ) &&
          activateMultipleJudgementAdd(props.judgementAdd, props.isManager) &&
          props.isAssignedLawyer && (
            <div className="add-document">
              <PrimaryButton
                title={translate(messages.addNewAddDocument, props)}
                lefticon={<AddCircleOutlineIcon className="icon" />}
                onClick={addNewJudgementAddDocument}
                className="add-judgement-add-pronoucing-style"
              />
            </div>
          )}
        {
          <div
            style={{
              margin: '5px',
              fontWeight: 'bold',
              fontSize: '18px',
              color: 'red',
            }}
          >
            {showDuplicateWarning
              ? translate(messages.duplicateJaddWarning, props)
              : ''}
          </div>
        }
        {!isEmpty(judgementAddDocuments) && (
          <div className="add-recap-bloc-title">
            {translate(
              judgementAddPronouncingMessages.judgementAddPronouncingTitle,
              props,
            )}
            {judgementAddDocuments.map((judgemenAddDocument, index: number) => (
              <JudgementAddPronouncingRecapAccordion
                judgementAdd={props.judgementAddStore}
                key={uniqueId('recap-judgementAdd-')}
                index={index}
                listings={props.listings}
                judgementAddDocument={judgemenAddDocument}
                readOnly={
                  props.readOnly ||
                  (props.isManager
                    ? false
                    : (get(judgemenAddDocument, 'lawyerCode')
                        ? get(judgemenAddDocument, 'lawyerCode')
                        : get(props.judgementAdd, 'lawyerCode')) !=
                      currentIntervenantStorage.get()?.sagis_code)
                }
                editJudgementAdd={
                  props.handleOnEditJudgementAddClick &&
                  props.handleOnEditJudgementAddClick(index)
                }
                requestMakeJudgementAddDocumentDecision={
                  props.requestMakeJudgementAddDocumentDecision
                }
                isManager={props.isManager}
                resetUploadedDocument={props.resetUploadedDocument}
                uploadDocument={props.uploadDocument}
                uploadedDocument={props.uploadedDocument}
                setDocumentId={props.setDocumentId}
                documentId={props.documentId}
                document={props.documentAdd}
                setDocument={props.setDocumentAdd}
                claimNumber={props.claimNumber}
                setJudgementAdd={props.setJudgementAdd}
                requestUpdateJudgementAddDocument={
                  props.requestUpdateJudgementAddDocument
                }
                isSaved
                judiciaryProcessId={props.judiciaryProcessId}
                setDialogOpenFirmReference={props.setDialogOpenFirmReference}
                isAssignedLawyer={props.isAssignedLawyer}
                requestGetJudgementAdd={props.requestGetJudgementAdd}
                expertReport={props.expertReport}
                judgementOnMerits={props.judgementOnMerits}
                handleIsDialogOpen={props.handleIsDialogOpen}
                sagisVictimInfo={props.sagisVictimInfo}
                sagisOpposingParties={props.sagisOpposingParties}
                claimAssignment={claimAssignment}
                feeNotes={props.feeNotes}
                setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
                policyInfo={props.policyInfo}
                requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
                openInvoiceFeeNoteUpdateInfoDialog={
                  openInvoiceFeeNoteUpdateInfoDialog
                }
                setOpenInvoiceFeeNoteUpdateInfoDialog={
                  setOpenInvoiceFeeNoteUpdateInfoDialog
                }
                setJudgemenAddDocumentToUpdate={setJudgemenAddDocumentToUpdate}
                handleValidateUpdateJudgementAddDocument={handleValidate}
              />
            ))}
          </div>
        )}
        {!isEmpty(newJudgementADDDocuments) &&
          newJudgementADDDocuments.map((judgemenAddDocument, index: number) => (
            <JudgementAddPronouncingRecapAccordion
              judgementAdd={props.judgementAddStore}
              key={uniqueId('recap-judgementAdd-')}
              index={index}
              listings={props.listings}
              judgementAddDocument={judgemenAddDocument}
              readOnly={
                props.readOnly ||
                (props.isManager
                  ? true
                  : get(judgemenAddDocument, 'lawyerCode') !=
                    currentIntervenantStorage.get()?.sagis_code)
              }
              editJudgementAdd={
                props.handleOnEditJudgementAddClick &&
                props.handleOnEditJudgementAddClick(index)
              }
              requestMakeJudgementAddDocumentDecision={
                props.requestMakeJudgementAddDocumentDecision
              }
              isManager={props.isManager}
              resetUploadedDocument={props.resetUploadedDocument}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              setDocumentId={props.setDocumentId}
              documentId={props.documentId}
              document={props.documentAdd}
              setDocument={props.setDocumentAdd}
              claimNumber={props.claimNumber}
              setJudgementAdd={props.setJudgementAdd}
              requestUpdateJudgementAddDocument={
                props.requestUpdateJudgementAddDocument
              }
              isAssignedLawyer={props.isAssignedLawyer}
              requestGetJudgementAdd={props.requestGetJudgementAdd}
              expertReport={props.expertReport}
              judgementOnMerits={props.judgementOnMerits}
              handleIsDialogOpen={props.handleIsDialogOpen}
              sagisVictimInfo={props.sagisVictimInfo}
              sagisOpposingParties={props.sagisOpposingParties}
              claimAssignment={claimAssignment}
              feeNotes={props.feeNotes}
              setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
              policyInfo={props.policyInfo}
              openInvoiceFeeNoteUpdateInfoDialog={
                openInvoiceFeeNoteUpdateInfoDialog
              }
              setOpenInvoiceFeeNoteUpdateInfoDialog={
                setOpenInvoiceFeeNoteUpdateInfoDialog
              }
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
              setJudgemenAddDocumentToUpdate={setJudgemenAddDocumentToUpdate}
              handleValidateUpdateJudgementAddDocument={handleValidate}
            />
          ))}
        {featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) &&
          !isEmpty(feeNotes) &&
          feeNotes?.map((item: FeeNoteType) => (
            <InvoiceInfoDialog
              open={openInvoiceFeeNoteUpdateInfoDialog}
              onClose={handleCloseInvoiceFeeNoteUpdate}
              handleValidate={handleValidateUpdateInvoice}
              invoiceNumber={invoiceNumberUpdate}
              invoiceDate={invoiceDateUpdate}
              setInvoiceNumber={setInvoiceNumberUpdate}
              setInvoiceDate={setInvoiceDateUpdate}
              resetUploadedDocument={props.resetUploadedDocument}
              setDocumentId={props.setDocumentId}
              docId={'Facture-0'}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              invoiceDocument={invoiceDocumentUpdate}
              setInvoiceDocument={setInvoiceDocumentUpdate}
              displayUpdateTitle={true}
              isManager={false}
              limitInvoiceDate={getLimitInvoiceIntervenant(
                get(props.listings, 'appConfig', []),
              )}
            />
          ))}
        {isActive && (
          <main>
            {isEmpty(judgementAddDocuments) && (
              <div>
                {translate(
                  judgementAddPronouncingMessages.judgementAddPronouncingTitle,
                  props,
                )}
              </div>
            )}
            {!isEmpty(judgementAddPronouncings) &&
              Object.entries(judgementAddPronouncings).map(
                ([key, judgement]: any, index: number) => {
                  return (
                    <JudgementAddForm
                      key={key}
                      listings={props.listings}
                      victims={getVictims(
                        props.isCivilProceeding,
                        props.currentJudiciaryProcess,
                        props.judgementAdd as any,
                        props.victims,
                        claimRecap,
                      )}
                      details={get(props.judgementAdd, 'judgementAdd', {})}
                      judgementAddPronouncing={judgement}
                      vehicules={props.vehicules}
                      uploadDocument={props.uploadDocument}
                      uploadedDocument={props.uploadedDocument}
                      resetUploadedDocument={props.resetUploadedDocument}
                      handleSetJudgementAddPronouncing={handleChangeJudgementAddProunoucing(
                        key,
                      )}
                      index={key}
                      saveForm={saveForm}
                      cancelJudgement={cancelJudgement(key)}
                      indexMap={index}
                      sagisVictimInfo={props.sagisVictimInfo}
                      sagisOpposingParties={props.sagisOpposingParties}
                      imagineDocuments={props.imagineDocuments}
                      policyInfo={props.policyInfo}
                      claimId={claimId}
                      requestGetDocByDocumentumId={
                        props.requestGetDocByDocumentumId
                      }
                    />
                  );
                },
              )}
          </main>
        )}
      </Forms>
      {!userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER) &&
        featureService.hasFeature(FEATURES.ADD_SUPPORT_DOCUMENTS) &&
        !userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER) &&
        judgementAdd &&
        (props.isAssignedLawyer ||
          (props.isManager &&
            featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER))) && (
          <main>
            {isEmpty(judgementAddSupportDocuments) && (
              <section className="add-recap-bloc">
                {props.documentAdd &&
                  props.setDocumentAdd &&
                  props.resetUploadedDocument &&
                  props.uploadDocument &&
                  props.uploadedDocument && (
                    <>
                      <div className="add-recap-bloc-title">
                        {translate(messages.supportDocument, props)}
                      </div>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        spacing={2}
                      >
                        <Grid item xs={3}>
                          <UploadDocumentBloc
                            index={1}
                            document={props.documentAdd}
                            setDocument={props.setDocumentAdd}
                            resetUploadedDocument={props.resetUploadedDocument}
                            uploadDocument={props.uploadDocument}
                            uploadedDocument={props.uploadedDocument}
                            docType={
                              DOCUMENT_TYPES.SUPPORT_DOCUMENT_JUDGEMENT_ADD
                            }
                            setDocumentId={props.setDocumentId}
                            docId={SUPPORT_DOC_JUDGEMENT_ADD_ID}
                            shouldNotCallReset={true}
                          />
                        </Grid>
                        <Grid item xs={3} style={{ marginTop: '20px' }}>
                          {!isEmpty(props.imagineDocuments) &&
                            featureService.hasFeature(
                              FEATURES.TRAITEMENT_IMAGINE_DOC,
                            ) && (
                              <ImportImagineDocumentButton
                                listings={props.listings}
                                managerNotifcationsInboxes={
                                  props.imagineDocuments
                                }
                                claimId={claimId}
                                imagineDocuments={props.imagineDocuments}
                                claimSagisInfo={resolveSagisClaim(
                                  props.policyInfo,
                                )}
                                uploadDocument={props.uploadDocument}
                                uploadedDocument={props.uploadedDocument}
                                setUploadedDocs={props.setDocumentAdd}
                                documentName={
                                  DOCUMENT_TYPES.SUPPORT_DOCUMENT_JUDGEMENT_ADD
                                }
                                documentType={
                                  DOCUMENT_TYPES.SUPPORT_DOCUMENT_JUDGEMENT_ADD
                                }
                                documentId={SUPPORT_DOC_JUDGEMENT_ADD_ID}
                                setDocumentId={props.setDocumentId}
                                requestGetDocByDocumentumId={
                                  props.requestGetDocByDocumentumId
                                }
                              />
                            )}
                        </Grid>
                      </Grid>
                    </>
                  )}
              </section>
            )}
          </main>
        )}
      {featureService.hasFeature(FEATURES.ADD_SUPPORT_DOCUMENTS) &&
        !isEmpty(judgementAddSupportDocuments) && (
          <section className="add-recap-bloc">
            <div className="add-recap-bloc-title">
              {translate(messages.supportDocument, props)}
            </div>
            <div className="support-document-info">
              <Document
                name={get(judgementAddSupportDocuments[0], 'name', '')}
                type={get(judgementAddSupportDocuments[0], 'type', '')}
                icon={
                  <VisibilityIcon
                    className="consult"
                    onClick={handleOpenDocument(
                      judgementAddSupportDocuments[0],
                      props.requestGetDocByDocumentumId,
                    )}
                  />
                }
              />
              {props.isManager && !props.isConsultation && (
                <DecisionDropDownSupportDocument
                  claimId={claimId}
                  claimNumber={props.claimNumber}
                  judiciaryProcessId={props.judiciaryProcessId}
                  supportDocument={judgementAddSupportDocuments[0]}
                  requestMakeDecisionSupportDocument={
                    props.requestMakeDecisionSupportDocument
                  }
                  claim={claim}
                  procedureType={get(props.judgementAdd, 'procedureType', '')}
                />
              )}
            </div>
          </section>
        )}

      {!isEmpty(newJudgementADDDocuments) && (
        <JudgementValidationButtons
          onValidation={onValidate}
          onCancel={() => setNewJudgementADDDocuments([])}
          cancelMessage={messages.cancelMessage}
        />
      )}
      {featureService.hasFeature(FEATURES.INCOME_CERTIFICATE) && (
        <React.Fragment>
          {!hasIncomeCertificate(
            getVictimsIncome(
              props.isCivilProceeding,
              props.currentJudiciaryProcess,
              props.judgementAdd as any,
              props.victims,
              claimRecap,
            ),
          ) &&
          !props.isConsultation &&
          !userPrivileges.userHasPrivilege(
            PRIVILEGES.ISCOURTMONITORINGMANAGER,
          ) &&
          ((!props.isCivilProceeding && !isEmpty(civilDocuments)) ||
            (props.isCivilProceeding &&
              !isEmpty(props.currentJudiciaryProcess))) ? (
            <IncomeCertificate
              victims={getVictimsIncome(
                props.isCivilProceeding,
                props.currentJudiciaryProcess,
                props.judgementAdd as any,
                props.victims,
                claimRecap,
              )}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              resetUploadedDocument={props.resetUploadedDocument}
              sagisVictimInfo={props.sagisVictimInfo}
              requestCreateIncomeCertificate={
                props.requestCreateIncomeCertificate
              }
              isManager={userPrivileges.userHasPrivilege(
                PRIVILEGES.ISCOURTMANAGER,
              )}
              setDocumentId={props.setDocumentId}
              documentId={props.documentId}
              claimNumber={props.claimNumber}
              claimId={claimId}
              judiciaryProcessId={props.judiciaryProcessId}
              dahirAmount={props.dahirAmount}
              riskKey={props.riskKey}
              claim={claim}
              listings={props.listings}
            />
          ) : (
            <IncomeCertificatesRecap
              victims={getVictimsIncome(
                props.isCivilProceeding,
                props.currentJudiciaryProcess,
                props.judgementAdd as any,
                props.victims,
                claimRecap,
              )}
              sagisVictimInfo={props.sagisVictimInfo}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              resetUploadedDocument={props.resetUploadedDocument}
              requestCreateIncomeCertificate={
                props.requestCreateIncomeCertificate
              }
              requestUpdateIncomeCertificate={
                props.requestUpdateIncomeCertificate
              }
              isManager={userPrivileges.userHasPrivilege(
                PRIVILEGES.ISCOURTMANAGER,
              )}
              setDocumentId={props.setDocumentId}
              documentId={props.documentId}
              claimNumber={props.claimNumber}
              claimId={claimId}
              judiciaryProcessId={props.judiciaryProcessId}
              readOnly={props.readOnly}
              requestMakeDecisionIncomeCertificate={
                props.requestMakeDecisionIncomeCertificate
              }
              isConsultation={props.isConsultation}
              riskKey={props.riskKey}
              claim={claim}
              judgementAdd={props.judgementAdd}
              dahirAmount={props.dahirAmount}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
              listings={props.listings}
            />
          )}
        </React.Fragment>
      )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) ? (
        <InvoiceFeeNoteDialog
          open={isSuccessPopinOpen}
          onClose={() => setIsSuccessPopinOpen(false)}
          decisionGenerationFeeNote={decisionGenerationFeeNote}
          setDecisionGenerationFeeNote={setDecisionGenerationFeeNote}
          handleValidate={
            decisionGenerationFeeNote
              ? handleOpenInvoicesInfoDialog
              : handleCloseSuccessDialog
          }
          shouldDisplayFirmReferenceField={
            isEmpty(lawyerFirmReference) && !props.isManager
          }
          setLawyerFirmRef={setLawyerFirmRef}
          lawyerFirmRef={lawyerFirmRef}
        />
      ) : (
        <SuccessDialog
          title={translate(messages.successDialogTitle, props)}
          secondaryButtonTitle={translate(
            messages.successDialogSecondaryButtonTitle,
            props,
          )}
          primaryButtonTitle={
            featureService.hasFeature(FEATURES.FEE_NOTE)
              ? translate(messages.successJudgementAdd, props)
              : translate(messages.successDialogPrimaryButtonTitle, props)
          }
          tertiaryButtonTitle={translate(
            { ...messages.doNotGenerateFeeNote },
            props,
          )}
          onTertiaryClick={doNotGenerateFeeNote}
          open={isSuccessPopinOpen}
          onClose={setIsSuccessPopinOpen}
          homePath={PAGES.LAWYER_HOME}
          onPrimaryClick={handleClick}
          isExpertReport={false}
          isPrimaryButtonDisabled={
            isEmpty(lawyerFirmReference) && !props.isManager
          }
        />
      )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) && (
        <InvoiceInfoDialog
          open={openInvoiceFeeNoteInfoDialog}
          onClose={handleCloseInvoiceFeeNote}
          handleValidate={handleValidateInvoice}
          invoiceNumber={invoiceNumber}
          invoiceDate={invoiceDate}
          setInvoiceNumber={setInvoiceNumber}
          setInvoiceDate={setInvoiceDate}
          resetUploadedDocument={props.resetUploadedDocument}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          invoiceDocument={invoiceDocument}
          setInvoiceDocument={setInvoiceDocument}
          limitInvoiceDate={getLimitInvoiceIntervenant(
            get(props.listings, 'appConfig', []),
          )}
        />
      )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) && (
        <DynamiqDialog
          open={openInvoiceInfoLawyers}
          onClose={() => setOpenInvoiceInfoLawyers(false)}
          handleValidate={() => {
            createMultipleJudgementAdd(true);
            setOpenInvoiceInfoLawyers(false);
          }}
          children={
            <>
              {extractIntervenant(
                get(props.listings, 'intervenants'),
                assignedLawyersByJudiciaryProcess,
              )?.map((item: any, index: any) => (
                <div style={{ marginTop: 10 }}>
                  <Typography style={{ fontWeight: 700 }}>
                    {translate(messages.intervenantName, props, {
                      IntervenantName: get(item, 'ItemDescription', null),
                    })}
                  </Typography>
                  <InvoiceFeeNotesManagerDialog
                    invoiceFeeNoteInfo={invoiceFeeNoteInfos[index]}
                    listings={props.listings}
                    invoiceFeeNoteInfos={invoiceFeeNoteInfos}
                    resetUploadedDocument={props.resetUploadedDocument}
                    uploadedDocument={props.uploadedDocument}
                    uploadDocument={props.uploadDocument}
                    assignedLawyersByJudiciaryProcess={
                      assignedLawyersByJudiciaryProcess
                    }
                    setDocumentId={
                      props.setDocumentId ? props.setDocumentId : () => {}
                    }
                    setInvoiceFeeNoteInfo={setInvoiceFeeNoteInfo}
                    documentId={props.documentId}
                    index={index}
                    displayFirmReferenceInput={
                      isNil(get(item, 'firmReference', null)) &&
                      featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE)
                    }
                    limitInvoiceDate={getLimitInvoiceManager(
                      get(props.listings, 'appConfig', []),
                    )}
                  />
                </div>
              ))}
            </>
          }
        />
      )}
    </Container>
  );
};

export default injectIntl(RecapADD);
